import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
// Initialize auth system to avoid circular dependency issues
import './lib/auth/init-auth-system';
import { networkDiagnostics } from './lib/utils/network-diagnostics';

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

// Only use StrictMode in production to avoid double-mounting issues in development
if (import.meta.env.PROD) {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} else {
  root.render(<App />);
}

// Add debugging helper for mobile
if (typeof window !== 'undefined') {
  (window as any).debugAuth = async () => {
    const { unifiedAuthService } = await import('@/lib/auth/unified-auth-service');
    const session = unifiedAuthService.getSession();
    const user = unifiedAuthService.getUser();
    const profile = unifiedAuthService.getUserProfile();
    const isLoading = unifiedAuthService.isLoading();
    
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    console.log('=== Auth Debug Info ===');
    console.log('Is Mobile:', isMobile);
    console.log('User Agent:', navigator.userAgent);
    console.log('Has Session:', !!session);
    console.log('Has User:', !!user);
    console.log('Has Profile:', !!profile);
    console.log('Is Loading:', isLoading);
    console.log('User Email:', user?.email);
    console.log('Profile Role:', profile?.role);
    
    return {
      isMobile,
      hasSession: !!session,
      hasUser: !!user,
      hasProfile: !!profile,
      isLoading,
      userEmail: user?.email,
      profileRole: profile?.role
    };
  };
  
  // Network diagnostics helper
  (window as any).diagnoseNetwork = () => networkDiagnostics.diagnoseAndLog();
  
  // Auto-check Supabase connection if there have been recent errors
  const checkConnection = async () => {
    const lastCheck = localStorage.getItem('last-network-check');
    const now = Date.now();
    
    // Only auto-check once per hour
    if (!lastCheck || now - parseInt(lastCheck) > 3600000) {
      const result = await networkDiagnostics.testSupabaseConnection();
      if (!result.reachable) {
        console.error('Supabase connection issue detected on startup');
        networkDiagnostics.diagnoseAndLog();
      }
      localStorage.setItem('last-network-check', now.toString());
    }
  };
  
  // Check connection after a short delay to not block app startup
  setTimeout(checkConnection, 2000);
}
